import { formatCurrency } from "../ControlStateHelper";
import '../PostControlInfoDetail/PostControlInfoDetail.scss';
import {draftjsToHTML} from '../WysiwygEditor/WysiwygHelpers';

const FinancialTable = props => {

	const renderFinancialFindings = () => {
		let findings = props.infoData.findings.filter(f => f.corrections.length > 0);
		return findings.map((f => {
			const result = renderCorrections(f);
			return result;
		}));

	};

	const renderCorrections = (finding) => {
		let corrections = finding.corrections;
		return finding.corrections.map((c, index) => {
			return <tr key={corrections.indexOf(c)} style={{ wordBreak: 'break-word' }}>
				<td>{finding.number}</td> 
				<td>{finding.findingKind.name}</td>
				<td> {c.indirectCosts === null ? '' : c.indirectCosts ? 'TAK' : 'NIE'}</td>
				<td>{c.kind}</td>
				<td>{c.rate?.toLocaleString('pl-PL') || ''}</td>
				<td>{c.base?.toLocaleString('pl-PL') || ''}</td>
				<td>{formatCurrency(c.wrongExpenditure, 2)}</td>
				<td>{c.projectNumber}</td>
				<td>{c.paymentClaim?.number || ''}</td>
				<td>{c.order?.orderNumber || ''}</td>
				<td>{c.influenceCurrent}</td>
				<td>{c.influenceFuture}</td>
			</tr>
		})
	};
	return (
		<div>
			<table style={{border: 1, width: '100%'}}>
				<thead style={{fontWeight: 'bold', verticalAlign: 'top'}}>
				<tr>
					<td>Numer ustalenia</td>
					<td>Typ ustalenia</td>
					<td>Korekta kosztów pośrednich</td>
					<td>Rodzaj korekty</td>
					<td>Stawka korekty</td>
					<td>Podstawa korekty</td>
					<td>Kwota wydatków niekwalifikowalnych</td>
					<td>Projekt</td>
					<td>Wniosek o płatność</td>
					<td>Zamówienia publiczne</td>
					<td>Wpływ na inne WoP</td>
					<td>Wpływ na przyszłe WoP</td>
				</tr>
				</thead>
				<tbody style={{verticalAlign: 'top'}}>
				{renderFinancialFindings()}
				</tbody>
			</table>
		</div>
	)
};

export default FinancialTable;
